const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/vehicles/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/fleet-management/vehicles/new')({
  staticData: {
    breadCrumb: 'Add Vehicle'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});